'use strict';

export { default as SalaryAccounts } from './salaryAccounts/salaryAccounts';
export { default as SalaryPayrolls } from './salaryPayrolls/salaryPayrolls';
